import React, {Component} from 'react'

import { Close, Notifications } from '@mui/icons-material';


export default ({notificationId, title, content, onDismiss = notificationId => {}}) => {
  return (
    <div className="tile-notification">
      <div className="tile-content">
        <h2><Notifications className="btn-point-events"/> {title}</h2>
        <p>{content}</p>
      </div>
      <button className="close-tile" onClick={() => onDismiss(notificationId)}>
        <Close className="btn-point-events"/>
      </button>
    </div>
  )
}
